module.exports = __webpack_public_path__ + "static/media/Curly-W-Red-solid.d3598d39.png";